import { Pages } from '../.generated/Project.CW.model';

export const isDefaultDate = '0001-01-01T00:00:00Z';
export const DEFAULT_THEME = 'theme-white';
export const GENERAL_PAGE_T1_TEMPLATE_ID = 'b25fc994-9d77-45d2-a643-9911c243ca32';
export const GENERAL_PAGE_T2_TEMPLATE_ID = 'd2b65608-e58c-4e89-9a58-25fd1474c762';
export const PROVIDER_PRIMARY_CARE_TEMPLATE_ID = '69c01af6-a958-4b60-b548-21b26f009590';
export const PROVIDER_TYPE_CMG_TEMPLATE_ID = '2a19dd0a-59cc-4e99-94fc-f7a78921ef73';
export const PRIMARYCARE_PAGETYPE_TEMPLATE_ID = '20188DC5-E36B-4C14-8A30-BFA520ABD1F3';

export const providerImportConstants = {
  tenantRootPath: '/sitecore/content/CW',
  specialtiesRootPath: 'Settings/MDStaff/Specialties',
  schedulingTypesRootPath: 'Settings/MDStaff/Scheduling Types',
  providersRootPath: 'Home/Providers',
  lookUpsRootPath: 'Global/MDStaff/Lookups',
  sitecoreProvidersFolderId: '{8F7EAA8E-89BA-4A27-B818-4FF7EF3AE225}',
  sitecoreSpecialtyTemplateId: '{4600FF49-3190-42A9-A736-289124E9A0A3}',
  sitecoreProviderBranchTemplateId: '{F7AD0AF0-984A-4C49-947D-5C71F276C184}',
  sitecoreProviderTemplateId: '{6DE30456-2D7D-4D28-BF1B-2B2B8AA42E62}',
  sitecoreAlphabetFolderTemplateId: '{A855A604-C636-4D4B-9E54-C999403C7461}',
  sitecoreManualProviderFolderTemplateId: '{F80B1D00-5AB9-4BBC-B11F-5DA29572CD49}',
  sitecoreLookUpTemplateId: '{0FCE0A23-85EA-4C6A-8B9A-F84418BF6776}',
  reviewTimelineLength: '547', // 18 months
  reviewMinRatingCount: '30', // Was set to 1 so that we get comments, however, this is NOT a filter for the API to only return providers with this many reviews. Per Press Ganey's doc: "Returns [comments] only when there are at least as many ratings as specified in minRatingCount.".
};

// Add page templates here. You can fetch the IDs from Leprechaun serialization
export const PageTemplateIds = {
  providerProfile: Pages.Constants.ProviderProfile.TemplateId,
  blogDetailPage: Pages.Constants.BlogDetailPage.TemplateId,
  locationHospital: Pages.LocationTypes.Constants.Hospital.TemplateId,
  locationPage: Pages.LocationTypes.Constants.LocationPage.TemplateId,
  locationMentalHealth: Pages.LocationTypes.Constants.MentalHealth.TemplateId,
  locationPrimaryCare: Pages.LocationTypes.Constants.PrimaryCare.TemplateId,
  locationSpecialtyCare: Pages.LocationTypes.Constants.SpecialtyCare.TemplateId,
  locationUrgentCare: Pages.LocationTypes.Constants.UrgentCare.TemplateId,
  specialtyPage: Pages.Constants.Specialty.TemplateId,
  conditionTreatmentPage: Pages.Constants.ConditionOrTreatment.TemplateId,
  teachingSheetPage: Pages.TeachingPages.Constants.TeachingSheets.TemplateId,
  homePage: Pages.Constants.HomePage.TemplateId,
};

export const PageTypeIds = {
  locationHospital: '204D45FB-49AB-4C0F-A2C2-C32DE5A41D56',
  locationSpecialty: '4339E6C5-1160-4172-85DA-9C9C5D1BEA22',
};

export type PageTemplateKey = keyof typeof PageTemplateIds;

export const CoveoFacetFields = {
  blogContentType: 'f-cwblogcontenttype',
  blogCategory: 'f-cwcategory',
  blogAuthorName: 'f-cwauthorname',
};

export const SiteNames = {
  childrens: 'childrens',
  giving: 'giving',
} as const;
